import React from 'react';

const OverallRiskGradeBar = ({ grade, score }) => {
  // Define grade ranges and colors (A > 90; B 80-89; C 70-79; D 60-69; F <60)
  const gradeConfig = {
    A: { min: 90, max: 100, color: 'bg-green-500', textColor: 'text-green-700', shadow: 'shadow-green-200' },
    B: { min: 80, max: 89, color: 'bg-lime-500', textColor: 'text-lime-700', shadow: 'shadow-lime-200' },
    C: { min: 70, max: 79, color: 'bg-yellow-500', textColor: 'text-yellow-700', shadow: 'shadow-yellow-200' },
    D: { min: 60, max: 69, color: 'bg-orange-500', textColor: 'text-orange-700', shadow: 'shadow-orange-200' },
    F: { min: 0, max: 59, color: 'bg-red-600', textColor: 'text-red-800', shadow: 'shadow-red-200' }
  };

  const grades = ['A', 'B', 'C', 'D', 'F'];
  const currentGrade = grade || 'F';
  const currentScore = score || 0;
  const config = gradeConfig[currentGrade];

  return (
    <div className="p-6 bg-gradient-to-br from-white to-gray-50 border-3 border-gray-300 rounded-2xl shadow-lg">
      {/* Header */}
      <div className="text-center mb-6">
        <div className="flex items-center justify-center mb-3">
          <span className="text-3xl mr-3">🎯</span>
          <h2 className="text-2xl font-bold text-gray-800">OVERALL RISK SCORE</h2>
        </div>
        
        {/* Large Grade Display */}
        <div className="flex items-center justify-center space-x-4 mb-4">
          <div className={`w-20 h-20 rounded-full ${config?.color || 'bg-gray-400'} flex items-center justify-center shadow-lg ${config?.shadow || ''}`}>
            <span className="text-3xl font-black text-white">{currentGrade}</span>
          </div>
          <div className="text-right">
            <div className="text-4xl font-bold text-gray-800">{currentScore}</div>
            <div className="text-lg text-gray-600">out of 100</div>
          </div>
        </div>
      </div>

      {/* Enhanced Grade Bar */}
      <div className="relative mb-4">
        <div className="flex space-x-2 h-12 rounded-xl overflow-hidden border-2 border-gray-400 shadow-inner">
          {grades.map((gradeLevel, index) => {
            const gradeConf = gradeConfig[gradeLevel];
            const isActive = gradeLevel === currentGrade;
            
            return (
              <div
                key={gradeLevel}
                className={`flex-1 relative transition-all duration-500 ${
                  isActive 
                    ? `${gradeConf.color} shadow-lg transform scale-105` 
                    : 'bg-gray-200 hover:bg-gray-300'
                }`}
              >
                {/* Grade Letter */}
                <div className={`absolute inset-0 flex items-center justify-center font-black text-lg ${
                  isActive ? 'text-white' : 'text-gray-500'
                }`}>
                  {gradeLevel}
                </div>
                
                {/* Active Pulse Effect */}
                {isActive && (
                  <>
                    <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-2 w-0 h-0 border-l-6 border-r-6 border-b-8 border-transparent border-b-white"></div>
                    <div className={`absolute inset-0 ${gradeConf.color} opacity-75 animate-pulse`}></div>
                  </>
                )}
              </div>
            );
          })}
        </div>

      </div>

      {/* Grade Range Labels */}
      <div className="flex justify-between text-sm font-medium text-gray-600">
        <span>A: 90-100</span>
        <span>B: 80-89</span>
        <span>C: 70-79</span>
        <span>D: 60-69</span>
        <span>F: 0-59</span>
      </div>

      {/* Risk Level Description */}
      <div className="mt-4 text-center">
        <div className={`inline-block px-4 py-2 rounded-full text-sm font-semibold ${
          currentGrade === 'A' ? 'bg-green-100 text-green-800' :
          currentGrade === 'B' ? 'bg-lime-100 text-lime-800' :
          currentGrade === 'C' ? 'bg-yellow-100 text-yellow-800' :
          currentGrade === 'D' ? 'bg-orange-100 text-orange-800' :
          'bg-red-100 text-red-800'
        }`}>
          {currentGrade === 'A' ? 'Excellent - Very Low Risk' :
           currentGrade === 'B' ? 'Good - Low Risk' :
           currentGrade === 'C' ? 'Average - Moderate Risk' :
           currentGrade === 'D' ? 'Below Average - High Risk' :
           'Poor - Very High Risk'}
        </div>
      </div>
    </div>
  );
};

export default OverallRiskGradeBar;